import { Column } from "../CustomDataTable/CustomDataTable";
import { additionalFieldColumns, commonFieldColumns } from "./ContactCommonColumns";

 
export const TransporterColumns = (props: any): Column[] => [
    ...commonFieldColumns(props),
  // {
  //   field: "totalTransporterOrderValue",
  //   headerName: "Transporter Cost",
  //   width: 150,
  //   defaultChecked: true,
  //   renderCell: (params: any) =>
  //     params.row.totalTransporterOrderValue === ""
  //       ? "-"
  //       : params.row.totalTransporterOrderValue.toFixed(props.sessionList?.decimalPoint || 2),
  // },
  ...additionalFieldColumns(props),
];